module.exports = __webpack_public_path__ + "static/media/home_logo_lg.dd59280d.png";